import { nanoid } from 'nanoid'

import {
  createFieldChoice,
  createFieldNps,
  createFieldOther,
  createFieldSkip,
  createFieldText,
  createFieldVideo,
} from '../../question/factories/Field'
import {
  createQuestionChoice,
  createQuestionNps,
  createQuestionOpenText,
  createQuestionVideo,
} from '../../question/factories/Question'

export const backgroundColors = ['#FFD6BF', '#B6EECB', '#FCC5DE']

export const QUESTIONS = [
  createQuestionOpenText({
    id: 0,
    title: 'Tell us about the best meal you have ever had. What made it so good? ',
    fields: [
      createFieldText({ id: 'field-1', title: 'What was the meal?' }),
      createFieldText({ id: 'field-2', title: 'What made it so good?' }),
      createFieldSkip(),
    ],
    characterLimit: 140,
  }),
  createQuestionVideo({
    id: 1,
    title: 'What do you think about fast food and why?',
    prompt: 'test promp \n - bullet 1 \n - bullet 2',
    fields: [createFieldVideo({ id: 'wow-video-field' }), createFieldSkip()],
  }),
  createQuestionChoice({
    id: 2,
    title: 'Which toppings do you prefer on pizza',
    maxAnswers: 2,
    fields: [
      createFieldChoice({ id: nanoid(), title: 'Pineapple' }),
      createFieldChoice({ id: nanoid(), title: 'Pepperoni' }),
      createFieldChoice({ id: nanoid(), title: 'Anchovy' }),
      createFieldChoice({ id: nanoid(), title: 'Olive' }),
      createFieldChoice({ id: nanoid(), title: 'BBQ sauce' }),
      createFieldOther(),
      createFieldSkip(),
    ],
  }),
  createQuestionNps({
    id: 3,
    title: 'Nps question',
    fields: [
      createFieldNps({
        id: 'nps',
        ratingToApiAnswerIdMap: new Map(Array.from({ length: 11 }).map((_, i) => [i, `id${i}`])),
      }),
      createFieldSkip(),
    ],
  }),
] as const
